@if (isLoading()) {
  <div class="features-loading">
    <span class="spinner-border spinner-border-sm" role="status"></span>
  </div>
} @else {
  <div class="features-container">
    <div class="features-list">
      @for (row of featureRows; track row.key) {
        <div class="feature-row">
          <span class="feature-label">{{ row.translateKey | translate }}</span>
          <label class="toggle-switch">
            <input
              type="checkbox"
              [checked]="features()[row.key]"
              (change)="toggle(row.key)"
            />
            <span class="toggle-slider"></span>
          </label>
        </div>
      }
    </div>

    @if (error()) {
      <div class="alert alert-danger mt-3">{{ error() | translate }}</div>
    }

    @if (saveSuccess()) {
      <div class="alert alert-success mt-3">{{ 'GLOBAL.SAVED' | translate }}</div>
    }

    <div class="features-actions">
      <button class="btn btn-primary" (click)="save()" [disabled]="isSaving()">
        @if (isSaving()) {
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        }
        {{ 'GLOBAL.SAVE' | translate }}
      </button>
    </div>
  </div>
}
